import { NgModule } from '@angular/core';
import { LocationListComponent } from './pages/location-list/location-list.component';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { SharedModule } from '@shared/shared.module';
import { LocationRoutingModule } from '.';

@NgModule({
    declarations: [LocationListComponent],
    imports: [CustomFormModule, LocationRoutingModule, SharedModule]
})
export class LocationModule {}
